module.exports = __webpack_public_path__ + "img/index_float.0c28c415.png";